import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Container, Box, CssBaseline, ThemeProvider, createTheme } from '@mui/material';

import Navbar from './components/sections/Navbar';
import Home from './components/sections/Home';
import Benefits from './components/sections/Benefits';
import HowItWork from './components/sections/HowItWork';
import OurStory from './components/sections/ourStory';
import Solutions from './components/sections/Solutions';
import AnalyticsDashboards from './components/sections/AnalyticsDashboards';
import OurValues from './components/sections/OurValues';
import ExpertsSection from './components/sections/ExpertsSection';
import ContactUs from './components/sections/ContactUs';
import GCCPresenceMap from './components/sections/GCCPresenceMap';
import Footer from './components/sections/Footer';
import OurFeeds from './components/sections/OurFeeds';
import AboutUs from './components/sections/AboutUs';

import AnimatedSection from './components/ui/AnimatedSection';

import AOS from 'aos';
import 'aos/dist/aos.css';

import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/josefin-sans/400.css';
import '@fontsource/josefin-sans/600.css';
import '@fontsource/josefin-sans/700.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';

const theme = createTheme({
  typography: {
   
    body1: {
            background: 'linear-gradient(to right, #020817, #041E2F, #000000)',
      
    },
   
  },
  palette: {
    primary: { main: '#1976d2', light: '#42a5f5', dark: '#1565c0', contrastText: '#ffffff' },
    secondary: { main: '#dc004e', light: '#ff5983', dark: '#9a0036', contrastText: '#ffffff' },
    healthcare: {
      blue: '#1976d2',
      lightBlue: '#e3f2fd',
      darkBlue: '#0d47a1',
      green: '#4caf50',
      lightGreen: '#e8f5e8',
      red: '#f44336',
      orange: '#ff9800',
      purple: '#9c27b0',
      gray: '#757575',
      lightGray: '#f5f5f5',
    },
    background: { default: '#ffffff', paper: '#ffffff' },
    text: { primary: '#212121', secondary: '#757575' },
  },
  shape: { borderRadius: 12 },
  breakpoints: { values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 } },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 12,
          fontWeight: 600,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          '&:hover': { boxShadow: '0 4px 12px rgba(0,0,0,0.15)' },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
          '&:hover': { boxShadow: '0 8px 30px rgba(0,0,0,0.12)' },
        },
      },
    },
    MuiPaper: { styleOverrides: { root: { borderRadius: 12 } } },
  },
});

const App = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
            width: '100%',
            overflowX: 'hidden',
            overflowY: 'hidden',
          }}
        >
          <Navbar />

          <Container maxWidth={false} disableGutters sx={{ flex: 1, width: '100%', padding: 0, margin: 0 }}>
            
            <AnimatedSection>
              <Box component="section" id="home">
                <Home />
              </Box>
            </AnimatedSection>

            <AnimatedSection>
              <Box component="section" id="about">
                <AboutUs />
              </Box>
            </AnimatedSection>


  <AnimatedSection>
              <Box component="section" id="our-story">
                <OurStory />
              </Box>
            </AnimatedSection>
            
            <AnimatedSection>
              <Box component="section" id="our-values">
                <OurValues />
              </Box>
            </AnimatedSection>

          

          
            <AnimatedSection>
              <Box component="section" id="howItWork">
                <HowItWork />
              </Box>
            </AnimatedSection>

            <AnimatedSection>
              <Box component="section" id="solution">
                <Solutions />
              </Box>
            </AnimatedSection>

            <AnimatedSection>
              <Box component="section" id="benefits">
                <Benefits />
              </Box>
            </AnimatedSection>

            <AnimatedSection>
              <Box component="section" id="analyticsDashboard">
                <AnalyticsDashboards />
              </Box>
            </AnimatedSection>

            <AnimatedSection>
              <Box component="section" id="our-team">
                <ExpertsSection />
              </Box>
            </AnimatedSection>

            <AnimatedSection>
              <Box component="section" id="our-feeds">
                <OurFeeds />
              </Box>
            </AnimatedSection>


            <AnimatedSection>
              <Box component="section" id="contact">
                <ContactUs />
              </Box>
            </AnimatedSection>

            <AnimatedSection>
              <Box component="section" id="GCCPresenceMap">
                <GCCPresenceMap />
              </Box>
            </AnimatedSection>
            
          </Container>

          <Footer />
        </Box>
      </Router>
    </ThemeProvider>
  );
};

export default App;
